<button class="p-0 bg-transparent border-0 d-flex flex-column align-content-center justify-content-center text-center"
    (click)="OpenPlateViewerWithPlate()">
    <mat-icon data-nosnippet class="d-block mx-auto outline">vrpano</mat-icon>
    <small *ngIf="!iconOnly" class="d-none d-md-block mx-auto">Plate Viewer</small>
</button>
